export const flightFreeBaggageType = {
  all: "全ての経路で含む",
  partial: "一部の経路で含む",
};
